import { memo } from 'react';

import CheckmarkIconSVG from '@/assets/checkmark-icon.svg?react';
import { merge } from '@/components';
import { Icon, IconProps } from '@/components/core';

const ICheckmarkIcon = ({ className, ...rest }: Omit<IconProps, 'SVGComponent'>) => {
  return <Icon className={merge('stroke-1.25', className)} SVGComponent={CheckmarkIconSVG} {...rest} />;
};

export const CheckmarkIcon = memo(ICheckmarkIcon) as typeof ICheckmarkIcon;
